import React, { createContext, useContext, useState, useCallback } from 'react';
import { ColocAPISortDirections } from '@/lib/coloc-api';
import { ContractsListSortType } from '@/lib/coloc-api/admin';

type ContractsSortingContextType = {
  sortDirection: ColocAPISortDirections | null;
  setSortDirection: (dir: ColocAPISortDirections | null) => void;
  selectedColumnToSort: ContractsListSortType | null;
  setColumnToSort: (col: ContractsListSortType) => void;
};

const ContractsSortingContext = createContext<ContractsSortingContextType | undefined>(undefined);

export const ContractsSortingProvider = ({ children }: { children: React.ReactNode }) => {
  const [sortDirection, setSortDirection] = useState<ColocAPISortDirections | null>(null);
  const [selectedColumnToSort, internalSetColumnToSort] = useState<ContractsListSortType | null>(null);

  const setColumnToSort = useCallback(
    (column: ContractsListSortType) => {
      if (selectedColumnToSort === column) {
        if (sortDirection) {
          if (sortDirection === 'ascending') {
            setSortDirection('descending');
          } else {
            internalSetColumnToSort(null);
            setSortDirection(null);
          }
        } else {
          setSortDirection('ascending');
        }
      } else {
        internalSetColumnToSort(column);
        setSortDirection('ascending');
      }
    },
    [selectedColumnToSort, sortDirection]
  );

  return (
    <ContractsSortingContext.Provider
      value={{
        sortDirection,
        setSortDirection,
        selectedColumnToSort,
        setColumnToSort,
      }}
    >
      {children}
    </ContractsSortingContext.Provider>
  );
};

export const useContractsSortingContext = () => {
  const ctx = useContext(ContractsSortingContext);
  if (!ctx) throw new Error('useContractsSortingContext must be used within a ContractsSortingProvider');
  return ctx;
};
